import React, {useEffect, useState} from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { WaveLoading } from 'react-loadingg';

import {
  // Budget,
  // TotalUsers,
  // TasksProgress,
  // TotalProfit,
  // LatestSales,
  // UsersByDevice,
  // LatestProducts,
  // LatestOrders,
  UserInfo,
  CarInfos,
  AdvertiseInfos
} from './components';

import { IsNoU } from 'common/utils';

// >> redux
import {
  getCategories,
} from 'redux/actions/categories';
// <<

// >> redux
import {
  getAreas,
  getGroups,
} from 'redux/actions/manage';
// <<

// >> redux
import {
  getDashboardInfo,
} from 'redux/actions/dashboards';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Dashboard = (props) => {

  const { 
    loadingCategory, 
    loadingArea, 
    loading, 
    // areas, 
    // groups, 
    dashboardInfo,
  } = props;

  const classes = useStyles();

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);

  const render_ad_infos = () => {
    if (IsNoU(dashboardInfo.adinfos) || !Array.isArray(dashboardInfo.adinfos))
      return (<div></div>);

    let ad_infos = dashboardInfo.adinfos;
    const loop_cnt = Math.floor(ad_infos.length%10===0?ad_infos.length/10:ad_infos.length/10+1);
    //console.log(loop_cnt);

    const render_data = [...Array(loop_cnt)].map((n, idx) => {
      const sub_ad_infos = ad_infos.slice(idx*10, idx*10+10);
      //console.log(sub_ad_infos);
      return (
        <Grid
          key={`dashboard_ad_info_${idx}`}
          item
          lg={4}
          md={6}
          xl={3}
          xs={12}
        >
          <AdvertiseInfos
            infos={sub_ad_infos} 
            />
        </Grid>
        );
    });

    return render_data;
  }

  useEffect(() => {
    //console.log("componentDidMount  ");
    props.getCategories();

    // props.getAreas();
    // props.getGroups();

    props.getDashboardInfo();

    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
    }

    return () => {
      //console.log("componentDidUnmount");
    };
  }, []); // empty-array means don't watch for any updates

  if (loadingCategory || loadingArea || loading) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          key={'dashboard_car_info'}
          item
          xs={12}
        >
          <CarInfos
            dashboard_info={dashboardInfo}
            //infos={dashboardInfo.deviceinfos}
            //groups={[]}
           />
        </Grid>

        {render_ad_infos()}

      </Grid>
    </div>
  );
};


Dashboard.propTypes = {
  loading: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.object),

  // areas: PropTypes.arrayOf(PropTypes.object),
  // groups: PropTypes.arrayOf(PropTypes.object),

  dashboardInfo: PropTypes.object,

//  getCategories: PropTypes.func
};

Dashboard.defaultProps = {
  loading: false,
  categories: [],

  // areas: [],
  // groups: [],

  dashboardInfo: {},

//  getCategories: () => {}
};

const mapStateToProps = state => ({
  loadingCategory: state.categories.loading,
  loadingArea: state.manage.loading,
  loading: state.dashboards.loading,

  categories: state.categories.categoriesList,

  // areas: state.manage.reged_areaList,
  // groups: state.manage.groupList,

  dashboardInfo: state.dashboards.dashboardInfo,
});

const mapDispatchToProps = dispatch => ({
  getCategories: () => {getCategories(dispatch)},

  getAreas: () => {getAreas(dispatch)},
  getGroups: () => {getGroups(dispatch)},

  getDashboardInfo: () => {getDashboardInfo(dispatch)},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);

// export default connect(
//   mapStateToProps,
//   {
//     getCategories,
//     getAreas: (dispatch) => {getAreas(dispatch)},
//     getGroups: (dispatch) => {getGroups(dispatch)},
//     //getDashboardInfo,
//   }
// )(Dashboard);
  
//export default Dashboard;
